import { render, staticRenderFns } from "./ReceiptInvoiceBa.vue?vue&type=template&id=2d2ef808&scoped=true&"
import script from "./ReceiptInvoiceBa.vue?vue&type=script&lang=js&"
export * from "./ReceiptInvoiceBa.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptInvoiceBa.vue?vue&type=style&index=0&id=2d2ef808&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ef808",
  null
  
)

export default component.exports